import type { ErrorListProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const ErrorListTemplate = ({ errors }: ErrorListProps) => (
  <Mtds.Alert data-color='danger' className='mt-4'>
    <Mtds.Heading>Validering av skjemaet feilet</Mtds.Heading>
    {/* Remove list-disc when list-style:none is removed from index.css */}
    <ul className='list-disc'>
      {errors.map((error) => (
        <li key={error.stack}>{error.message || error.stack}</li>
      ))}
    </ul>
  </Mtds.Alert>
)
